import React from 'react';
import classNames from 'classnames';
import Image from '../../elements/Image';

const Logo = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'brand',
    className
  );

  return (
    <div
      {...props}
      className={classes}
    >
      <h1 className="m-0">
          <Image
            src={require('./../../../assets/images/gooey-removebg-preview (1).png')}
            alt="Tidy"
            width={200}
            height={200} />
      </h1>
    </div>
  );
}

export default Logo;